import useShallowEqualSelector from '../components/core/useShallowEqualSelector';

// eslint-disable-next-line import/prefer-default-export
export const useAppTimezone = () => useShallowEqualSelector((state) => state?.user.appTimezone);
